/**
 * Created by Andrey Popov on 2/24/22.
 */

Telly.PRIZES.undersea2 = [
    [{
        units: [
            { currentType: "searesource", stage: 0 },
            { currentType: "seahero", stage: 0 },
            { code: "worker", stage: 0 }
        ]
    }],
    [{
        units: [
            { currentType: "searesource", stage: 1 },
            { currentType: "seahero", stage: 1 },
            { code: "worker", stage: 1 },
            { code: "seamagicplant", stage: 1 }
        ]
    }],
    [{
        units: [
            { currentType: "searesource", stage: 2 },
            { currentType: "seahero", stage: 2 },
            { code: "worker", stage: 2 },
            { code: "seamagicplant", stage: 1 },
            { code: "crystal", stage: 1 }
        ]
    }]
];

MissionTree.PRIZES.undersea2 = [{
    amount: 5,
    units: [
        { code: "seasnail", stage: 1 },
        { code: "seasnail", stage: 1 },
        { code: "seasnail", stage: 1 },
        { code: "seasnail", stage: 2 }
    ]
}];

const Undersea2SourceMine = {
    prize: function (level, unit) {
        const sourceAmounts = [2, [2, 3], [3, 4], [4, 5], [5, 6]];
        const chestStages = [0, 0, 0];

        if (level === unit.getData().mineable.tasks.length - 1) {
            return [{
                units: [{ code: `${unit.getResource()}chest`, stage: chestStages[unit.stage] }]
            }];
        }

        return [{
            amount: sourceAmounts[level],
            units: [{ code: unit.getResource(), stage: 0 }]
        }, {
            amount: [1, 3],
            units: [{ code: "seasnail", stage: 0 }]
        }];
    }
};

const Undersea2FruitMine = {
    prize: function (level, unit) {
        return [{
            amount: 5,
            probabilities: [0.166, 0.166, 1],
            units: [
                { code: unit.code, stage: 1 },
                { code: "coins", stage: 0 },
                { code: unit.code, stage: 0 }
            ]
        }];
    }
};

const Undersea2GeneratorMine = {
    prize: function (level, unit) {
        return [{
            amount: 3,
            probabilities: [0.75, 0.25],
            units: [
                { code: `${unit.getResource()}source`, stage: 0 },
                { code: unit.getResource(), stage: 0 }
            ]
        }, {
            amount: [2, 5],
            units: [
                { code: "seasnail", stage: 0 },
                { code: "seasnail", stage: 1 }
            ]
        }];
    }
};

Mines.seafruit = Undersea2FruitMine.prize;
Mines.seasource = Undersea2SourceMine.prize;
Mines.seagrowing = WandsGrowing.prize;
Mines.seagenerator = Undersea2GeneratorMine.prize;

Ruins.TIERS.undersea2 = {
    cheap: {
        soft: 59,
        rewards: [
            { code: "energy", stage: 0, amount: 1 },
            { code: "worker", stage: 0, amount: 1 },
            { code: "seastrawberry", stage: 0, amount: 2 }
        ]
    },
    costly: {
        hard: 249,
        rewards: [
            { code: "energy", stage: 2, amount: 2 },
            { code: "crystal", stage: 2, amount: 3 },
            { code: "seasack", stage: 2, amount: 1 },
            { code: "worker", stage: 4, amount: 1 }
        ]
    }
};

cleverapps.styles.undersea2 = {
    fogBlockWand: {
        x: { align: "left", dx: -7 },
        y: { align: "center", dy: 15 }
    }
};

cleverapps.styles.undersea2[PixelsSwarm.ADS] = {
    distanceDisappear: 1000,
    speed: { x: 35, y: -18 },
    collect: {
        x: { align: "center", dx: 0 },
        y: { align: "center", dy: 0 },
        delay: 150
    }
};

AchievementsConfig.registerExpedition("undersea2", {
    fog: "fog5",
    force: Forces.LANDMARK_DONOR_SLOT2,
    donors: "sea2fisherman"
});
UnitsLibrary.CODES_BY_TAB.undersea2 = [
    ["seahero", "searubyhero"],
    ["searesource"],
    ["seafruit"],
    ["seagrowing", "seasource"],
    ["seachest"],
    ["seamagicplant", "snailfeast", "snailhouse"]
];

UnitsLibrary.EXPEDITION_PREFIXES.undersea2 = "sea";

ShopWindow.TABS.UNITS_EXPEDITION_UNDERSEA2 = 13;

UnitsShop.SHOPS.undersea2 = [{
    tab: ShopWindow.TABS.UNITS_EXPEDITION_UNDERSEA2,
    unit: { code: "seashop", stage: 0 }
}];

UnitsShop.PRODUCTS[ShopWindow.TABS.UNITS_EXPEDITION_UNDERSEA2] = {
    refreshTimeout: "6 hours",
    refreshPrice: 199,

    default: [{
        unit: {
            code: "sea2walrusruby",
            stage: 0,
            amount: 1,
            onlyIfNotDone: true
        },
        price: 49,
        type: Product.TYPE_HARD,
        left: 30
    }, {
        unit: {
            code: "walrusruby",
            stage: 0,
            amount: 1,
            onlyIfNotDone: true
        },
        price: 49,
        type: Product.TYPE_HARD,
        left: 30
    }, {
        unit: {
            code: "searudolf",
            stage: 0,
            amount: 1
        },
        price: 1500,
        type: Product.TYPE_HARD,
        left: 1
    }, {
        unit: {
            code: "seafreechest",
            stage: 0,
            amount: 1
        },
        type: Product.TYPE_FREE,
        left: 1
    }, {
        unit: {
            code: "seasack",
            stage: 0,
            amount: 2
        },
        type: Product.TYPE_FREE,
        left: 1
    }, {
        unit: {
            code: "seasack",
            stage: 2,
            amount: 1
        },
        price: 149,
        type: Product.TYPE_HARD,
        left: 3
    }, {
        unit: {
            code: "seashopchest",
            stage: 0,
            amount: 1
        },
        price: 49,
        type: Product.TYPE_HARD,
        left: 10
    }, {
        unit: {
            code: "seashopchest",
            stage: 1,
            amount: 1
        },
        price: 129,
        type: Product.TYPE_HARD,
        left: 15
    }, {
        unit: {
            code: "seashopchest",
            stage: 2,
            amount: 1
        },
        price: 319,
        type: Product.TYPE_HARD,
        left: 30
    }, {
        unit: {
            code: "crystal",
            stage: 3,
            amount: 1
        },
        price: 119,
        type: Product.TYPE_HARD,
        left: 5
    }, {
        unit: {
            code: "worker",
            stage: 4,
            amount: 1
        },
        price: 79,
        type: Product.TYPE_HARD,
        left: 5
    }]
};

PixelsPlanner.AVAILABLE.undersea2 = {
    fog: "fog3"
};

PixelsSwarm.UNDERSEA2 = "undersea2";

PixelsSwarmConfig[PixelsSwarm.UNDERSEA2] = {
    pages: ["undersea2"],
    reward: [{
        units: [
            { currentType: "searesource", stage: 0 },
            { currentType: "seahero", stage: 0 },
            { code: "seamagicplant", stage: 0 },
            { code: "seastrawberry", stage: 0 }
        ]
    }]
};

PixelsSwarmConfig[PixelsSwarm.ADS].pages.push("undersea2");

cleverapps.styles.PixelView[PixelsSwarm.UNDERSEA2] = cleverapps.overrideStyles(cleverapps.styles.PixelViewTemplate, {}, true);